import {
    IS_MOBILE
} from './types';

export const screenResize = (status) => ({
    type: IS_MOBILE,
    payload: status
});
